import { render, staticRenderFns } from "./lp-create.vue?vue&type=template&id=2ff7ad79&"
import script from "./lp-create.vue?vue&type=script&lang=js&"
export * from "./lp-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports